<template>
  <a-card class="style1">
    <h3 class="pb-2">Upload Video</h3>
    <a-upload-dragger name="file" :multiple="false" :action="signedUrl" :before-upload="handleBeforeUpload" :showUploadList="false" @change="handleChange">
      <p class="ant-upload-drag-icon">
        <a-icon type="inbox" />
      </p>
      <p class="ant-upload-text">Click or drag file to this area to upload</p>
    </a-upload-dragger>

    <a-progress
      v-if="percent > 0 && percent < 100"
      :stroke-color="{
        '0%': '#108ee9',
        '100%': '#87d068',
      }"
      :title="'Uploading...'"
      :percent="percent"
    />

    <a-row v-if="downloadUrl" style="margin-top: 2rem">
      <a-col class="text-center">
        <span class="download-url">
          <a-button type="link" class="text-underline" style="color: #333" v-clipboard:copy="downloadUrl" v-clipboard:success="clipboardSuccess">{{ downloadUrl }}</a-button>
        </span>
      </a-col>
    </a-row>

    <a-row v-if="downloadUrl" style="margin-top: 2rem">
      <a-col class="text-center" style="max-width: 540px !important; margin: 0 auto">
        <div id="reviewVideo"></div>
      </a-col>
    </a-row>
  </a-card>
</template>
<script>
import Uploader from '@/services/UploadService';
export default {
  data() {
    return {
      fileList: [],
      s3: null,
      signedUrl: null,
      percent: -1,
      downloadUrl: null,
    };
  },
  methods: {
    handleBeforeUpload() {
      return false;
    },
    setupReviewPlayer() {
      const containerId = 'reviewVideo';
      const container = document.getElementById(containerId);
      if (!container || typeof window.jwplayer !== 'function') {
        return;
      }

      const player = window.jwplayer(containerId);
      if (player && typeof player.setup === 'function') {
        player.setup({
          file: this.downloadUrl,
          primary: 'flash',
          type: 'mp4',
          autostart: false,
          repeat: false,
        });
      }
    },
    async handleChange(e) {
      const video = e.file;
      if (video) {
        try {
          this.percent = 0;
          const uploaded = await new Uploader().uploadVideoFile(video, percent => (this.percent = percent));
          this.downloadUrl = uploaded.Location;

          this.$notification['success']({
            message: 'Video uploaded successfully!',
          });

          this.$nextTick(() => {
            this.setupReviewPlayer();
          });
        } catch (error) {
          console.error('Video upload error:', error);
          this.percent = -1;
          this.$notification['error']({
            message: 'Video Upload Failed',
            description: error.message || 'Failed to upload video. Please check your AWS credentials and try again.',
            duration: 0,
          });
        }
      }
    },
    clipboardSuccess() {
      this.$notification['success']({
        message: 'Copied to clipboard',
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#reviewVideo {
  background: black;
}
</style>
